import ModalPresenter from "../../modal/presenter/modal.js";

import SuggestionsPresenter from "../../suggestions/presenter/suggestions.js";

import CitySelectModalSectionView from "../view/city-select-modal-section.js";
import CitySelectModalItemView from "../view/city-select-modal-item.js";

import {
  render
} from "../../render/render.js";

import {
  debounce
} from "../../../utils/debounce.js";

import {
  defaultModalModelData,
  ActionType,
  MODAL_ITEMS_NUMBER,
  INPUT_FOCUS_TIMEOUT_TIME,
  SUGGESTIONS_SEARCH_MIN_CHARS,
  MODAL_MAIN_CLASS
} from "../const.js";

import {
  ActionType as SuggestionsActionType
} from "../../suggestions/const.js";

import {
  CITIES_LIST
} from "../data/cities-list.js";

export default class CitySelectModal extends ModalPresenter {
  constructor(currentLocality) {
    super();

    this._modalMainClass = MODAL_MAIN_CLASS;
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        defaultModalModelData,
        {
          currentLocality
        }
    ));

    this._modalCurrentItemView = null;
    this._modalItemsViews = [];
    this._suggestionsPresenter = null;
    this._modalSectionView = new CitySelectModalSectionView();

    this._handleCloseButtonFocus = this._handleCloseButtonFocus.bind(this);
    this._handleItemButtonClick = this._handleItemButtonClick.bind(this);
    this._handleItemButtonFocus = this._handleItemButtonFocus.bind(this);
    this._handleCitySearchInput = this._handleCitySearchInput.bind(this);
    this._handleCitySearchInputDebounced = debounce(this._handleCitySearchInput);
    this._handleCitySearchFormSubmit = this._handleCitySearchFormSubmit.bind(this);
    this._handleSuggestionsObservation = this._handleSuggestionsObservation.bind(this);
  }

  _getSuggestions(value) {
    return CITIES_LIST
      .slice()
      .filter((item) => item.name.toLowerCase().indexOf(value) !== -1)
      .map((item) => {
        item.matchIndex = item.name.toLowerCase().indexOf(value);

        return item;
      })
      .sort((left, right) => left.matchIndex - right.matchIndex)
      .map((item) => item.name)
      .filter((item) => item !== this._model.getData().currentLocality);
  }

  _processInit() {
    super._processInit();
    const listElement = this._modalSectionView.getCitiesListElement();

    const currentView = new CitySelectModalItemView(this._model.getData().currentLocality);
    render(listElement, currentView.getElement());
    currentView.activate();
    this._modalCurrentItemView = currentView;

    CITIES_LIST
      .slice(0, MODAL_ITEMS_NUMBER)
      .forEach((item) => {
        const view = new CitySelectModalItemView(item.name);

        render(listElement, view.getElement());

        view.setButtonClickHandler(this._handleItemButtonClick);
        view.setButtonFocusHandler(this._handleItemButtonFocus);

        if (item.name === this._model.getData().currentLocality) {
          view.hide();
        }

        this._modalItemsViews.push(view);
      });

    this._modalSectionView.setInputInputHandler(this._handleCitySearchInputDebounced);
    this._modalSectionView.setFormSubmitHandler(this._handleCitySearchFormSubmit);
  }

  _processChangeCity() {
    this._modalCurrentItemView.deactivate();

    const currentView = this._modalItemsViews.find((item) => item.getLocality() === this._model.getData().currentLocality);

    if (currentView) {
      currentView.activate();
    }

    this._modalInstance.close();
  }

  _processSuggestionsShow(suggestions) {
    this._suggestionsPresenter = new SuggestionsPresenter(
        this._modalSectionView.getFormElement(),
        suggestions
    );
    this._suggestionsPresenter.init();
    this._suggestionsPresenter.addObserver(this._handleSuggestionsObservation);
  }

  _processSuggestionsHide() {
    this._suggestionsPresenter.removeObserver(this._handleSuggestionsObservation);
    this._suggestionsPresenter.destroy();
    this._suggestionsPresenter = null;
  }

  _processSuggestionItemSelect(currentLocality) {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isSuggestionsShown: false
        }
    ), ActionType.HIDE_SUGGESTIONS);

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isActive: false,
          currentLocality
        }
    ), ActionType.CHANGE_CITY, {
      currentLocality
    });
  }

  _handleModalDone() {
    super._handleModalDone();

    this._modalSectionView.setCloseButtonFocusHandler(this._handleCloseButtonFocus);
    setTimeout(() => {
      this._modalSectionView.focusInputElement();
    }, INPUT_FOCUS_TIMEOUT_TIME);
  }

  _handleModalDestroy() {
    super._handleModalDestroy();

    this._currenLocality = null;
    this._modalCurrentItemView = null;
    this._modalItemsViews = [];
  }

  _handleCitySearchInput(inputValue) {
    if (this._model.getData().isSuggestionsShown) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            isSuggestionsShown: false
          }
      ), ActionType.HIDE_SUGGESTIONS);
    }

    if (inputValue === `` || inputValue.length < SUGGESTIONS_SEARCH_MIN_CHARS) {
      return;
    }

    const suggestions = this._getSuggestions(inputValue);

    if (suggestions.length === 0) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isSuggestionsShown: true
        }
    ), ActionType.SHOW_SUGGESTIONS, {
      suggestions
    });
  }

  _handleCitySearchFormSubmit(evt, inputValue) {
    evt.preventDefault();

    if (inputValue === `` || inputValue.length < SUGGESTIONS_SEARCH_MIN_CHARS || this._model.getData().isSuggestionsShown) {
      return;
    }

    const suggestions = this._getSuggestions(inputValue);

    if (suggestions.length === 0) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isSuggestionsShown: true
        }
    ), ActionType.SHOW_SUGGESTIONS, {
      suggestions
    });
  }

  _handleCloseButtonFocus() {
    if (this._model.getData().isSuggestionsShown) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            isSuggestionsShown: false
          }
      ), ActionType.HIDE_SUGGESTIONS);
    }
  }

  _handleItemButtonClick(currentLocality) {
    const modelData = this._model.getData();

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          isActive: false,
          currentLocality
        }
    ), ActionType.CHANGE_CITY, {
      currentLocality
    });
  }

  _handleItemButtonFocus() {
    if (this._model.getData().isSuggestionsShown) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            isSuggestionsShown: false
          }
      ), ActionType.HIDE_SUGGESTIONS);
    }
  }

  _handleSuggestionsObservation(action, payload) {
    switch (action) {
      case SuggestionsActionType.ITEM_SELECT:
        this._processSuggestionItemSelect(payload.selectedText);
        break;
    }
  }

  _handleChangeData(action, payload) {
    super._handleChangeData(action, payload);

    switch (action) {
      case ActionType.CHANGE_CITY:
        this._processChangeCity();
        break;
      case ActionType.SHOW_SUGGESTIONS:
        this._processSuggestionsShow(payload.suggestions);
        break;
      case ActionType.HIDE_SUGGESTIONS:
        this._processSuggestionsHide();
        break;
    }
  }
}
